var map = {
	"./case_studies.json": 14599,
	"./case_studies_0824.json": 29586,
	"./case_studies_BG.json": 19307,
	"./case_studies_CS.json": 41690,
	"./case_studies_DA.json": 13479,
	"./case_studies_DE.json": 94203,
	"./case_studies_EL.json": 59501,
	"./case_studies_ES.json": 92436,
	"./case_studies_ET.json": 49141,
	"./case_studies_FI.json": 34301,
	"./case_studies_FR.json": 18920,
	"./case_studies_GA.json": 36124,
	"./case_studies_HR.json": 73514,
	"./case_studies_HU.json": 92807,
	"./case_studies_IT.json": 63569,
	"./case_studies_LT.json": 16096,
	"./case_studies_LV.json": 86418,
	"./case_studies_MT.json": 78669,
	"./case_studies_NL.json": 4694,
	"./case_studies_PL.json": 30196,
	"./case_studies_PT.json": 80172,
	"./case_studies_RO.json": 10051,
	"./case_studies_SK.json": 50082,
	"./case_studies_SL.json": 72447,
	"./case_studies_SV.json": 69601,
	"./case_studies_online.json": 25611
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2172;